import React from "react";
import styled from "styled-components";
//
import { Image } from "components/prismic";
//

export default ({ image }) => (
  <Wrap>
    <Image {...image} />
  </Wrap>
);
//
const Wrap = styled.div`
  padding: 0.5rem;
`;
